import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, Observable, tap} from "rxjs";
import {LoaderService} from "./loader.service";
import {EnvironmentService} from "./environment.service";
import {ActionResult, ActionResultList, ApplicationFormSettings} from "@model";

@Injectable({providedIn: 'root'})
export class ApplicationFormSettingsService {
  constructor(private http: HttpClient, private loaderService: LoaderService, private environmentService: EnvironmentService) {
  }

  fetchApplicationFormSettings(raceId: number | undefined, hideLoading?: boolean): Observable<ApplicationFormSettings | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResult<ApplicationFormSettings>>(this.environmentService.getApiUrl() + "/api/public/applicationformsettings/getbyraceid", raceId)
      .pipe(
        tap(() => {
          if (!hideLoading) {
            this.loaderService.dismissLoading()
          }
        }),
        map((value: ActionResult<ApplicationFormSettings>) => {
          if (value && value.result) {
            return value.result;
          } else {
            return null;
          }
        })
      );

  }

  fetchApplicationFormSettingsByEventId(eventId: number | undefined, hideLoading?: boolean): Observable<ApplicationFormSettings[] | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResultList<ApplicationFormSettings[], number>>(this.environmentService.getApiUrl() +
      "/api/applicationformsettings/getbyeventid", eventId)
      .pipe(
        tap(() => {
          if (!hideLoading) {
            this.loaderService.dismissLoading()
          }
        }),
        map((value: ActionResultList<ApplicationFormSettings[], number>) => {
          if (value && value.result) {
            return value.result;
          } else {
            return [];
          }
        })
      );
  }


  updateApplicationFormSettings(formSettings: ApplicationFormSettings, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/applicationformsettings/update", formSettings)
      .subscribe((actionResult: ActionResult<boolean>) => {
        if (actionResult.resultCode !== -1) {
          onSuccess();
        } else {
          onError();
        }
      });
  }
}
